import { render, staticRenderFns } from "./PatchnoteText.vue?vue&type=template&id=c4e93ed0"
import script from "./PatchnoteText.vue?vue&type=script&lang=js"
export * from "./PatchnoteText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports